module.exports = __webpack_public_path__ + "img/pwd.4231d8dd.jpg";